var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProductArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C5.38323 24 0 18.6168 0 12C0 5.38318 5.38323 0 12 0C18.6168 0 24 5.38318 24 12C24 18.6168 18.6168 24 12 24ZM12 1.55393C6.23996 1.55393 1.55398 6.24022 1.55398 12C1.55398 17.7598 6.23996 22.446 12 22.446C17.76 22.446 22.4461 17.7598 22.4461 12C22.4461 6.24022 17.76 1.55393 12 1.55393ZM17.8273 13.4908H9.94139C9.94139 13.4908 11.853 15.4026 13.0372 16.5863C13.5427 17.0921 13.5427 17.9121 13.0372 18.4178C12.9538 18.5012 12.8693 18.5854 12.7859 18.6688C12.2804 19.1747 11.4604 19.1747 10.9546 18.6688C9.40475 17.1193 6.32921 14.0434 5.25693 12.9709C5.014 12.7283 4.87753 12.3988 4.87753 12.0554V11.9446C4.87753 11.6014 5.014 11.272 5.25693 11.029C6.32921 9.95674 9.40475 6.88095 10.9546 5.33134C11.4604 4.82554 12.2804 4.82554 12.7859 5.33134C12.8693 5.41449 12.9538 5.49921 13.0372 5.58231C13.5427 6.08815 13.5427 6.90789 13.0372 7.41368C11.853 8.59757 9.94139 10.5094 9.94139 10.5094H17.8273C18.5426 10.5094 19.1223 11.0893 19.1223 11.8044V12.1958C19.1223 12.9111 18.5426 13.4908 17.8273 13.4908Z",
    fill: "#666E7A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductArrow);
export default __webpack_public_path__ + "static/media/product_arrow.a25f0f9e9922cd68c231c2fe11de8a02.svg";
export { ForwardRef as ReactComponent };